import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { inject, observer } from 'mobx-react'
import { Layout, PageHeader, Row, Col } from 'antd'

import EditCollectionPopup from '@components/Popup/EditCollectionPopup'

import SearchBar from './SearchBar'
import List from './List'

@inject((store: any) => {
    const { collectionsStore, popupStore, categoriesStore, collectionTypesStore } = store
    return { collectionsStore, popupStore, categoriesStore, collectionTypesStore }
})
@observer
class HealthRights extends Component<any, any> {
    componentDidMount() {
        this.udpateCollections()
    }
    udpateCollections = async () => {
        const { collectionsStore, categoriesStore, collectionTypesStore } = this.props
        await categoriesStore.updateCategoriesList('HEALTH_RIGHT')
        await collectionsStore.getCollections()
        await collectionTypesStore.getCollectionTypes()
    }
    render() {
        return (
            <Layout style={{ padding: '0 1rem' }}>
                <PageHeader onBack={() => window.history.back()} title="זכויות מאתר כל הבריאות" />
                <Row>
                    <Col>
                        <SearchBar />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <List udpateCollections={this.udpateCollections} />
                    </Col>
                </Row>
                <EditCollectionPopup />
            </Layout>
        )
    }
}

export default withRouter(HealthRights)
